import { Activity, FlaskConical } from 'lucide-react';

interface WorkspaceTypeBadgeProps {
  workspaceType?: 'live' | 'sandbox';
  className?: string;
}

export default function WorkspaceTypeBadge({ workspaceType, className = '' }: WorkspaceTypeBadgeProps) {
  const isSandbox = workspaceType === 'sandbox';
  const Icon = isSandbox ? FlaskConical : Activity;

  return (
    <span className={`inline-flex items-center gap-1 text-[10px] font-medium ${isSandbox
      ? 'text-violet-700 dark:text-violet-300'
      : 'text-emerald-700 dark:text-emerald-300'} ${className}`}>
      <Icon aria-hidden="true" className="h-3 w-3" />
      <span>{isSandbox ? 'Sandbox' : 'Live'}</span>
    </span>
  );
}
